export default Object.freeze({
  ACTIVE: 'active',
  DELETED: 'deleted',
  INACTIVE: 'inactive',
  INVITED: 'invited',
});
